// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "checkbox-1ar0t";
export { _1 as "__esModule", _2 as "checkbox" }
export default { "__esModule": _1, "checkbox": _2 }
